import { useEffect, useState } from 'react';

import { rulesApi } from '../../api/rules.js';
import { SearchableSelect } from '../../components/ui/SearchableSelect.jsx';
import { PRICE_LEVELS } from '../../constants/priceLevels.js';

const INPUT_STYLE = { width: '100%', padding: 4, fontSize: 12 };

export function HolOverrideAddForm({ onSave, onCancel }) {
  const [form, setForm] = useState({
    site_code: '', location_name: '', labor_metric_code: '',
    pay_category_name: '', override_price_level: 'HOLIDAY',
  });
  const [sites,         setSites]         = useState([]);
  const [lmOptions,     setLmOptions]     = useState([]);
  const [lmLoading,     setLmLoading]     = useState(false);
  const [payCategories, setPayCategories] = useState([]);

  useEffect(() => {
    rulesApi.getOverrideSites().then(setSites).catch(() => {});
    rulesApi
      .getOverridePayCategories()
      .then((cats) => {
        setPayCategories(cats);
        if (cats.length > 0) {
          setForm((prev) => ({ ...prev, pay_category_name: cats[0].name }));
        }
      })
      .catch(() => {});
  }, []);

  const handleSiteChange = (siteCode) => {
    const site = sites.find((s) => s.site_code === siteCode);
    setForm((prev) => ({
      ...prev,
      site_code: siteCode,
      location_name: site?.ns_location_name || site?.short_name || '',
      labor_metric_code: '',
    }));
    setLmOptions([]);
    if (siteCode) {
      setLmLoading(true);
      rulesApi.getOverrideLaborMetrics(siteCode)
        .then(setLmOptions)
        .catch(() => {})
        .finally(() => setLmLoading(false));
    }
  };

  const set = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));

  const siteOptions = sites.map((s) => ({
    value: s.site_code, label: `${s.site_code} — ${s.short_name}`,
  }));
  const lmSelectOptions = lmOptions.map((lm) => ({
    value: lm.code,
    label: `${lm.code}${lm.name ? ' — ' + lm.name : ''}`,
  }));

  return (
    <div style={{
      background: '#fffde7', border: '1px solid #ffd54f',
      borderRadius: 8, padding: 16, marginBottom: 16,
    }}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>Add Pay Code Override</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '8px 16px' }}>
        <div>
          <label style={{ fontSize: 11 }}>Location Code *</label>
          <SearchableSelect
            options={siteOptions}
            value={form.site_code}
            onChange={handleSiteChange}
            placeholder="Search sites..."
            renderOption={(o) => o.label}
            width="100%"
          />
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Location Name</label>
          <input
            value={form.location_name}
            readOnly
            style={{ ...INPUT_STYLE, background: '#f4f4f4', border: '1px solid #ccc', borderRadius: 4 }}
          />
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Labor Metric *</label>
          <SearchableSelect
            options={lmSelectOptions}
            value={form.labor_metric_code}
            onChange={(v) => set('labor_metric_code', v)}
            placeholder={
              lmLoading
                ? 'Loading...'
                : !form.site_code
                  ? 'Select site first'
                  : 'Search labor metrics...'
            }
            renderOption={(o) => o.label}
            disabled={!form.site_code || lmLoading}
            width="100%"
          />
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Pay Category</label>
          <select
            value={form.pay_category_name}
            onChange={(e) => set('pay_category_name', e.target.value)}
            style={INPUT_STYLE}
          >
            {payCategories.map((c) => (
              <option key={c.name} value={c.name}>
                {c.name} (default: {c.default_price_level})
              </option>
            ))}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Override Price Level</label>
          <select
            value={form.override_price_level}
            onChange={(e) => set('override_price_level', e.target.value)}
            style={INPUT_STYLE}
          >
            {PRICE_LEVELS.map((pl) => <option key={pl} value={pl}>{pl}</option>)}
          </select>
        </div>
      </div>

      <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
        <button
          className="btn btn-sm btn-success"
          onClick={() => onSave(form)}
          disabled={!form.site_code || !form.labor_metric_code}
        >
          Save
        </button>
        <button className="btn btn-sm" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
